var $ = require('jquery')

$(function() {
  var sidebarHotNews = $('.side .side-hot')
  if (!sidebarHotNews.length) { return }

  var tabsContainer = sidebarHotNews.find(".gb-tab:eq(0)")
  tabsContainer
    .tabs(sidebarHotNews.find(".gb-tab-pn:eq(0) > div"), { event:'mouseover' });

  sidebarHotNews.find(".js-rank").each(function(i){
    $(this).find('li').each(function(j){
      j=j+1;
      $('em', $(this)).text(j);
    })
  })
})
